// Belegverfügbarkeit, optionale Prüfung und Rechnungserfordernis sind unabhängig.
export function nachweisVorhanden(evidence, kind = 'content') {
  const stand = (evidence && evidence[kind]) || {};
  if (typeof stand.receiptPresent === 'boolean') return stand.receiptPresent;
  const dateien = (evidence && evidence.files) || {};
  const dateiVorhanden = typeof stand.filePresent === 'boolean' ? stand.filePresent
    : Number(kind === 'bank' ? dateien.bankCount : dateien.invoiceCount) > 0;
  const externVorhanden = typeof stand.externalPresent === 'boolean' ? stand.externalPresent
    : stand.sourceType !== 'preliminary' && stand.effectiveStatus !== 'review_stale'
      && stand.availabilityStatus !== 'availability_stale'
      && (stand.availability === 'external' || (!stand.availability && stand.status === 'verified' && !stand.documentId));
  return dateiVorhanden || externVorhanden;
}

export function nachweisStatus(evidence, kind) {
  if (!evidence) return { text: 'Nachweisstand noch nicht geladen', color: 'grey' };
  const pruefung = evidence[kind] || {};
  const dateien = evidence.files || {};
  const dateiAnzahl = Number(kind === 'bank' ? dateien.bankCount : dateien.invoiceCount) || 0;
  const dateiVorhanden = typeof pruefung.filePresent === 'boolean' ? pruefung.filePresent : dateiAnzahl > 0;
  const vorlaeufig = pruefung.sourceType === 'preliminary';
  const geprueft = (typeof pruefung.effectiveVerified === 'boolean'
    ? pruefung.effectiveVerified : pruefung.status === 'verified') && !vorlaeufig
      && pruefung.effectiveStatus !== 'review_stale';
  const dateiGeprueft = pruefung.effectiveStatus === 'verified_with_file'
    || (!pruefung.effectiveStatus && dateiVorhanden);
  if (geprueft && !nachweisVorhanden(evidence, kind)) return {
    text: 'Optional geprüft · Beleg fehlt', color: 'warning',
  };
  if (geprueft) return {
    text: dateiGeprueft ? 'Datei vorhanden · geprüft'
      : `Extern vorhanden · geprüft${dateiVorhanden ? ' · Datei zusätzlich vorhanden' : ''}`,
    color: 'success',
  };
  if (dateiVorhanden) return { text: 'Datei vorhanden', color: 'success' };
  if (nachweisVorhanden(evidence, kind)) return { text: 'Extern vorhanden (ohne Upload)', color: 'success' };
  if (pruefung.availabilityStatus === 'availability_stale') return {
    text: 'Externe Belegangabe veraltet', color: 'warning',
  };
  if (vorlaeufig) return { text: 'Vorläufiger Nachweis · Rechnung fehlt', color: 'warning' };
  return {
    text: kind === 'bank' ? 'Nicht hinterlegt (optional)' : 'Beleg fehlt',
    color: kind === 'bank' ? 'grey' : 'warning',
  };
}

export function nachweisWarnungen(evidence) {
  if (!evidence) return [];
  const warnungen = [];
  const rechnung = evidence.invoiceRequirement || {};
  const inhalt = evidence.content || {};
  const erforderlich = typeof rechnung.effectiveRequired === 'boolean'
    ? rechnung.effectiveRequired : rechnung.status !== 'not_required';
  if (erforderlich && !nachweisVorhanden(evidence)) {
    warnungen.push('Rechnungsbeleg fehlt: Datei anhängen oder einen extern vorhandenen Beleg eintragen.');
  }
  if (inhalt.sourceType === 'preliminary') {
    warnungen.push('Eine Bestellübersicht / ein vorläufiger Nachweis ist noch keine Rechnung.');
  }
  if (rechnung.effectiveStatus === 'review_stale') {
    warnungen.push('Die Ausnahme vom Rechnungserfordernis ist veraltet. Begründung erneut prüfen; bis dahin ist eine Rechnung erforderlich.');
  }
  return warnungen;
}

export function dokumentDateiVorhanden(dokument) {
  return dokument.hasContent === true || dokument.hasContent === 1;
}

export function cacheNachweisAktualisieren(response) {
  // Nur einen bereits freigegebenen Offline-Cache fortschreiben, niemals neu anlegen.
  try {
    const gespeichert = localStorage.getItem('f410');
    if (!gespeichert || (!response.evidence && !response.settlement)) return;
    const cache = JSON.parse(gespeichert);
    const daten = cache.save || {};
    const evidence = response.evidence;
    if (evidence && evidence.targetType === 'cost') {
      const kosten = (daten.kosten || []).find((k) => String(k.id) === String(evidence.targetId));
      if (kosten) kosten.evidence = evidence;
    }
    (daten.auftraege || []).forEach((auftrag) => {
      if (evidence && evidence.targetType === 'order_document') {
        const dokument = (auftrag.dokumente || []).find((d) => String(d.id) === String(evidence.targetId));
        if (dokument) dokument.evidence = evidence;
      }
      if (response.settlement && String(auftrag.id) === String(response.settlement.orderId)) {
        auftrag.settlement = response.settlement;
        auftrag.offeneRechnungen = { betrag: Number(response.settlement.openAmountMinor) / 100 };
        auftrag.status = response.settlement.currentStatus;
        (response.settlement.invoices || []).forEach((rechnung) => {
          const ziel = (auftrag.dokumente || []).find((d) => String(d.id) === String(rechnung.documentId));
          if (ziel) ziel.settlement = rechnung;
        });
      }
    });
    localStorage.setItem('f410', JSON.stringify(cache));
  } catch {
    // Ein nicht verfügbarer Browser-Cache darf die Serverbestätigung nicht verwerfen.
  }
}
